export default {"src":"/_next/static/media/visaLogo.df8444d1.svg","height":7,"width":18,"blurWidth":0,"blurHeight":0};